import React, { useState, useRef, useEffect } from "react";
import StickyHeader from "../../../../components/ModuleCommon/StickyHeader/StickyHeader";
import FormContract from "./FormContract";
import { contractApi } from "../api/contractApi";
import {
  // eslint-disable-next-line no-unused-vars
  formatAsLocalDate,
  // eslint-disable-next-line no-unused-vars
  convertUTCToLocalTime, // Format Date or convert sever UTC time to local, DON'T DELETE
  // eslint-disable-next-line no-unused-vars
  convertDateToUTC,
  // eslint-disable-next-line no-unused-vars
  convertTimeToUTC, // Must convert to UTC before sending, DON'T DELETE
} from "../utils/formatters";

const NewContract = () => {
  const officeCode = "OFFC_101";
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [infoData, setInfoData] = useState({
    "Contract Code": {
      type: "text",
      value: "CNTR-" + new Date().getFullYear() + "-001",
      readOnly: true,
    },
    "Effective Date": {
      type: "date",
      value: new Date().toISOString().split("T")[0],
    },
    "Expiration Date": {
      type: "date",
      value: "",
    },
    Status: {
      type: "dropdown",
      value: "DRAFT",
      options: ["DRAFT", "ACTIVE", "EXPIRED"],
    },
  });

  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(64);
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    const updateHeaderHeight = () => {
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight);
      }
    };

    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);
    return () => window.removeEventListener("resize", updateHeaderHeight);
  }, []);

  const handleInfoChange = (fieldName, newValue) => {
    setInfoData((prev) => ({
      ...prev,
      [fieldName]: { ...prev[fieldName], value: newValue },
    }));

    // 实时验证日期有效性
    if (fieldName.includes("Date")) {
      validateDates();
    }
  };

  const validateForm = () => {
    const errors = [];

    // 必填字段验证
    if (!infoData["Effective Date"].value) {
      errors.push("Effective Date is required");
    }

    // 日期顺序验证
    if (infoData["Expiration Date"].value) {
      const effective = new Date(infoData["Effective Date"].value);
      const expiration = new Date(infoData["Expiration Date"].value);
      if (effective >= expiration) {
        errors.push("Expiration date must be after effective date");
      }
    }

    setValidationError(errors.join("; "));
    return errors.length === 0;
  };

  const validateDates = () => {
    const effective = new Date(infoData["Effective Date"].value);
    const expiration = new Date(infoData["Expiration Date"].value);

    if (expiration && effective >= expiration) {
      setValidationError("Expiration date must be after effective date");
    } else {
      setValidationError("");
    }
  };

  const handleSaveDraft = () => {
    if (!validationError) {
      //       // 这里调用保存草稿的API
    }
  };

  const handleSubmitContract = async () => {
    if (!validateForm() || isSubmitting) return;

    setIsSubmitting(true);
    try {
      const contractDTO = {
        contractCode: infoData["Contract Code"].value,
        status: infoData.Status.value,
        effectiveDate: convertDateToUTC(infoData["Effective Date"].value),
        expirationDate: infoData["Expiration Date"].value
          ? convertDateToUTC(infoData["Expiration Date"].value)
          : null,
        laneIds: [], // 暂时传空数组
      };

      const response = await contractApi.createContract(
        officeCode,
        contractDTO
      );
      //       // 成功后可跳转或提示
      alert("Contract submitted successfully!");
    } catch (error) {
      let errorMessage = "Submission failed";
      if (error.response) {
        errorMessage =
          error.response.data.message ||
          JSON.stringify(error.response.data.errors);
      }
      setValidationError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const contractTemplates = [
    "Standard Contract",
    "Custom Terms Agreement",
    "International Shipping",
  ];

  const buttons = [
    {
      label: isSubmitting ? "Submitting..." : "Submit Contract",
      type: "primary",
      onClick: handleSubmitContract,
      disabled: !!validationError || isSubmitting,
    },
    {
      label: "Save Draft",
      type: "secondary",
      onClick: handleSaveDraft,
      disabled: !!validationError,
    },
  ];

  return (
    <div className="w-full h-full flex flex-col">
      <div
        ref={headerRef}
        className="sticky top-0 z-50 bg-white shadow-md w-full"
      >
        <StickyHeader
          infoData={infoData}
          onInfoChange={handleInfoChange}
          templates={contractTemplates}
          onSelectTemplate={(template) => {}}
          buttons={buttons}
          validationMessage={validationError}
        />
      </div>

      <div
        className="flex-1 overflow-y-auto bg-gray-50 w-full p-6"
        style={{ height: `calc(100vh - ${headerHeight}px)` }}
      >
        <FormContract laneIds={[]} />
      </div>
    </div>
  );
};

export default NewContract;
